<ng-container class="agpr-mentionContent" *ngIf="mention">
    <ng-container *ngIf="isTakeOverPanel; else normalView">
        <ng-container *ngTemplateOutlet="mentionContentPanel"></ng-container>
    </ng-container>

    <ng-template #mentionContentPanel>
        <!-- Mention Content Panel -->
        <agpr-panel
            [showHeader]="false"
            class="agpr-mentionContent-panel"
        >
            <a
                *ngIf="mention.isLexisNexis"
                href="http://www.lexisnexis.com"
                target="_blank"
            >
                <img
                    src="/app/assets/images/lexisNexisFullLogo.png"
                    [alt]="'MediaType.lexisNexis' | localize"
                    class="agpr-mentionContent-brandedLogo"
                />
            </a>
            <img
                *ngIf="mention.isBurrelles"
                src="/app/assets/images/burrellesIconUpdate.png"
                [alt]="'MediaType.burrelles.logo' | localize"
                class="agpr-mentionContent-brandedLogo"
                agprTooltip="MediaType.burrelles"
                tooltipPosition="left"
            />
            <article
                [id]="id + '.article'"
                class="agpr-mention"
            >
                @if (!mention.isFinancialTimes) {
                    @if (openAiPermission) {
                        <div class="agpr-mentionContent-translate">
                            <agpr-mention-translation-tabs
                                [selectedTabIndex]="selectedTabIndex"
                                [mention]="mention"
                                (tabChanged)="tabChanged($event)"
                                [tabsHeadingLevel]="5"
                            ></agpr-mention-translation-tabs>
                        </div>
                    }

                    <agpr-mention-set-preferred
                        [id]="id"
                        [openAiPermission]="openAiPermission"
                        [selectedTabIndex]="selectedTabIndex"
                        [mention]="mention"
                        [autoSave]="true"
                        (tabChanged)="tabChanged($event)"
                        [isLanguagePanelHalfWidth]="isLanguagePanelHalfWidth"
                    ></agpr-mention-set-preferred>
                }
                <div
                    [ngClass]="{'agpr-mentionContent-body-container': openAiPermission && !mention.isFinancialTimes}"
                >
                    <div class="agpr-mentionContent-headline">
                        @if (mention.tvEyesPodcastID) {
                            <agpr-button
                                class="agpr-mentionContent-headline-link"
                                [style]="buttonTypes.link"
                                (click)="openTvEyesPodcastPlayer()"
                            >
                                <ng-container *ngTemplateOutlet="headlineContent"></ng-container>
                            </agpr-button>
                        } @else if (isTvEyes) {
                            <agpr-button
                                class="agpr-mentionContent-headline-link"
                                [style]="buttonTypes.link"
                                (click)="openTVEyesDialog()"
                            >
                                <ng-container *ngTemplateOutlet="headlineContent"></ng-container>
                            </agpr-button>
                        } @else if (mention.url && canLinkOut) {
                            <a
                                [href]="mention.url"
                                target="_blank"
                                class="agpr-mentionContent-headline-link"
                                [id]="id + '.sourceLink'"
                            >
                                <ng-container *ngTemplateOutlet="headlineContent"></ng-container>
                            </a>
                        } @else {
                            <ng-container *ngTemplateOutlet="headlineContent"></ng-container>
                        }

                        <ng-template #headlineContent>
                            @if (mention.headline) {
                                @if (selectedTabIndex === tabIds.ORIGINAL) {
                                    <span
                                        class="agpr-mentionContent-headlineValue"
                                        [innerHTML]="mention.headline | highlightKeywords:highlightKeywords"
                                    ></span>
                                } @else if (selectedTabIndex === tabIds.TRANSLATED) {
                                    <span
                                        class="agpr-mentionContent-headlineValue"
                                        [innerHTML]="mention?.translation?.headline | indexHighlight:mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup"
                                    ></span>
                                }
                            } @else {
                                <span class="agpr-mentionContent-headlineValue">
                                    {{ mention.mediaType.noHeadlineMessage | localize }}
                                </span>
                            }
                        </ng-template>
                    </div>
                    <div class="agpr-mentionContent-metadata">
                        <div class="agpr-mentionContent-metadata--publication">
                            <ng-container *ngIf="mention.publication.name">
                                <ng-container *ngIf="isLegacyTargetingUser">
                                    <a
                                        class="agpr-mentionContent-link"
                                        [id]="id + '.publicationLink'"
                                        *ngIf="(
                                            (mention.publication.outletUrl && !isLegacyTargetingUser)
                                            || (mention.publication.agilityOutletURL && isLegacyTargetingUser)
                                        ); else pubNameLegacy"
                                        [href]="mention.publication.outletUrl"
                                        target="_blank"
                                    >
                                        <ng-container *ngTemplateOutlet="pubNameLegacy"></ng-container>
                                    </a>
                                    <ng-template #pubNameLegacy>
                                        <span>{{ mention.publication?.name }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="!isLegacyTargetingUser">
                                    <agpr-button
                                        *ngIf="mention.publication?.uuid; else pubName"
                                        [id]="id + '.publicationLink'"
                                        class="agpr-mentionContent-link"
                                        [style]="buttonTypes.link"
                                        (click)="outletClicked.emit()"
                                    >
                                        <ng-container *ngTemplateOutlet="pubName"></ng-container>
                                    </agpr-button>
                                    <ng-template #pubName>
                                        <span>{{ mention.publication?.name }}</span>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="agpr-mentionContent-metadata--author">
                            <ng-container *ngIf="mention.author.name">
                                <span>{{ mention.linkedinData?.type === linkedinTypeEnum.REPOST ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                                <span>{{ mention.isRetweet ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                                <span>{{ mention.isTweetReply ? ('Mention.TweetReply' | localize) : "" }}</span>
                                <ng-container *ngIf="isLegacyTargetingUser">
                                    <a
                                        class="agpr-mentionContent-link"
                                        [id]="id + '.authorLink'"
                                        *ngIf="mention.author.contactUrl; else authorNameLegacy"
                                        [href]="mention.author.contactUrl"
                                        target="_blank"
                                    >
                                        <ng-container *ngTemplateOutlet="authorNameLegacy"></ng-container>
                                    </a>
                                    <ng-template #authorNameLegacy>
                                        <span>{{ mention.author?.name }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="!isLegacyTargetingUser">
                                    <agpr-button
                                        *ngIf="mention.author?.uuid; else authorName"
                                        [id]="id + '.authorLink'"
                                        class="agpr-mentionContent-link"
                                        [style]="buttonTypes.link"
                                        (click)="contactClicked.emit()"
                                    >
                                        <ng-container *ngTemplateOutlet="authorName"></ng-container>
                                    </agpr-button>
                                    <ng-template #authorName>
                                        <span>{{ mention.author?.name }}</span>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="agpr-mentionContent-metadata--datePublished">
                            <span class="agpr-mentionContent-metadataLabel">
                                {{ 'Mention.datePublished' | localize }}
                            </span>
                            <ng-container *ngIf="preferences">
                                {{ mention.datePublished | changeTimeZone: preferences.timeZone: dateFormat }}
                            </ng-container>
                        </div>
                        <div
                            *ngIf="mention.dateAvailable"
                            class="agpr-mentionContent-metadata--dateAvailable"
                        >
                            <span class="agpr-mentionContent-metadataLabel">
                                {{ 'Mention.dateAvailable' | localize }}
                            </span>
                            <ng-container *ngIf="preferences">
                                {{ mention.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat }}
                            </ng-container>
                        </div>
                    </div>
                    <section class="agpr-mentionContent-body">
                        <ng-container *ngIf="selectedTabIndex === tabIds.ORIGINAL">
                            <p
                                class="agpr-mentionContent-paragraph"
                                *ngFor="let paragraph of bodyParagraphs"
                                [innerHTML]="
                                    paragraph
                                        | mentionLinks : mention.mediaType.id
                                        | indexHighlightSup
                                "
                            >
                            </p>
                            <agpr-original-tweet
                                [tweetData]="mention.tweetData"
                            ></agpr-original-tweet>
                        </ng-container>
                        <ng-container *ngIf="selectedTabIndex === tabIds.TRANSLATED">
                            <p
                                class="agpr-mentionContent-paragraph"
                                *ngFor="let paragraph of mention?.translation?.paragraphs"
                                [innerHTML]="
                                    paragraph
                                        | mentionLinks : mention.mediaType.id
                                        | indexHighlightSup
                                "
                            >
                            </p>
                            <agpr-original-tweet
                                [tweetData]="mention.tweetData"
                            ></agpr-original-tweet>
                        </ng-container>
                    </section>
                    <section
                        *ngIf="mention.cachedUrl"
                    >
                        <agpr-button
                            (click)="window.open(mention.cachedUrl, '_blank')"
                            [label]="'Mention.details.viewPdfButtonLabel'"
                            [style]="buttonTypes.tertiary"
                        ></agpr-button>
                    </section>
                    <ng-container *ngIf="selectedTabIndex === tabIds.ORIGINAL">
                        @if (mention.summary && !mention.isFinancialTimes) {
                            <section
                                class="agpr-mentionContent-summaryHeading"
                            >
                                {{ ('Mention.details.contextualSnippet' | localize) }}
                            </section>
                            <section class="agpr-mentionContent-summaryBody">
                                <p
                                    class="agpr-mentionContent-paragraph"
                                    *ngFor="let paragraph of summaryParagraphs"
                                    [innerHTML]="
                                        paragraph
                                            | mentionLinks : mention.mediaType.id
                                            | highlightKeywords: highlightKeywords
                                    "
                                >
                                </p>
                            </section>
                        } @else if (mention.isFinancialTimes) {
                            <agpr-financial-times-attribution
                                [mention]="mention"
                            ></agpr-financial-times-attribution>
                        }
                    </ng-container>
                    <ng-container *ngIf="selectedTabIndex === tabIds.TRANSLATED">
                        <ng-container
                            *ngIf="mention.translation?.summary && mention.translation?.summaryParagraphs"
                        >
                            <section
                                class="agpr-mentionContent-summaryHeading"
                            >
                                {{ ('Mention.details.contextualSnippet' | localize) }}
                            </section>
                            <section class="agpr-mentionContent-summaryBody">
                                <p
                                    class="agpr-mentionContent-paragraph"
                                    *ngFor="let paragraph of mention.translation?.summaryParagraphs"
                                    [innerHTML]="
                                        paragraph
                                            | mentionLinks : mention.mediaType.id
                                            | indexHighlight:mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup
                                    "
                                >
                                </p>
                            </section>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="attachments.length">
                        <td class="agpr-mentionContent-summaryHeading">
                            {{ ('Mention.details.attachments' | localize) }}
                        </td>
                        <section>
                            <ng-container *ngFor="let attachment of attachments">
                                <agpr-button
                                    class="agpr-mentionContent-attachment"
                                    [style]="buttonTypes.link"
                                    (click)="downloadAttachment(attachment)"
                                >
                                    {{ attachment.name }}
                                </agpr-button>
                            </ng-container>
                        </section>
                    </ng-container>
                </div>
                @if (showImageList) {
                    <div
                        class="agpr-mentionContent-imageList"
                        [ngClass]="{'agpr-mentionContent-imageList-custom': showOriginalImageSize}"
                    >
                        <agpr-image-list
                            [images]="mention.images"
                            [showPopover]="!showOriginalImageSize"
                            [showPreferredImageButton]="!!mention?.mentionId"
                            (preferredImageChanged)="updatePreferredImage($event)"
                            [useMentionCardErrorStyle]="useMentionCardErrorTemplate"
                        ></agpr-image-list>
                    </div>
                }
                <div
                    *ngIf="(mention.isPmgXcago || mention.viewerUrlType === viewerUrlTypeEnum.PDF) && mention.viewerUrl"
                    class="agpr-mentionContent-viewPdf"
                >
                    <a
                        class="agpr-mentionContent-viewPdf-link"
                        [id]="id + '_pmgXcagoViewPdf'"
                        [href]="mention.viewerUrl + '?mode=PDF'"
                        target="_blank"
                    >
                        {{ 'Mention.details.pmgXcago.viewMentionPdf' | localize }}
                    </a>
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                </div>
            </article>
            <div
                class="agpr-mentionContent-brandedFooterBar"
                *ngIf="mention.isLexisNexis"
            >
                <a
                    class="agpr-mentionContent-brandedFooterBarLink"
                    [id]="id + '.brandedFooterLinkGeneral'"
                    href="http://www.lexisnexis.com/terms/general/"
                    target="_blank"
                >
                    {{ 'Mention.details.lexisNexis.termsAndConditions' | localize }}
                </a>
                <span class="agpr-mentionContent-brandedFooterBarLink-separator">|</span>
                <a
                    class="agpr-mentionContent-brandedFooterBarLink"
                    [id]="id + '.brandedFooterLinkPrivacy'"
                    href="http://www.lexisnexis.com/terms/privacy/"
                    target="_blank"
                >
                    {{ 'Mention.details.lexisNexis.privacyPolicy' | localize }}
                </a>
                <span class="agpr-mentionContent-brandedFooterBarLink-separator">|</span>
                <a
                    class="agpr-mentionContent-brandedFooterBarLink"
                    [id]="id + 'brandedFooterLinkCopyright'"
                    href="http://www.lexisnexis.com/terms/copyright.aspx"
                    target="_blank"
                >
                    {{ 'Mention.details.lexisNexis.copyright' | localize: { year: currentYear } }}
                </a>
            </div>
        </agpr-panel>
    </ng-template>

    <ng-template #normalView>
        <ng-container *ngTemplateOutlet="mentionContentPanel"></ng-container>
        <!--
            The clip view needs to be shown/hidden instead of conditionally re-rendered
            so that the iframe element is already rendered when the src is added.
            Otherwise, the load event on the iframe could fire before Angular registers it.
        -->
        <agpr-panel
            *ngIf="isCriticalMention && isCriticalMentionValid && criticalMentionSlimPlayerURL"
            header="Mention.details.mentionView"
        >
            <div
                class="agpr-mentionContent-mentionNotShareable"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Mention.details.criticalMentionUnavailable' | localize }}
                </agpr-message>
            </div>
        </agpr-panel>
        <agpr-message
            *ngIf="isCriticalMention && !isCriticalMentionValid"
            [severity]="messageSeverityEnum.info"
        >
            {{ criticalMentionFeedbackMessage | localize }}
        </agpr-message>
        <!-- Social Media Embed View -->
        <div
            *ngIf="socialEmbedURL || socialEmbedCode"
            class="agpr-mentionContent-socialView"
        >
            <agpr-panel
                header="Mention.details.mentionView"
            >
                <div
                    class="agpr-mentionContent-socialContainer"
                    [ngClass]="'agpr-mentionContent-socialContainer--' + mention.mediaType.id"
                    [agprLoading]="!isSocialFrameLoaded"
                >
                    <iframe
                        *ngIf="socialEmbedURL"
                        class="agpr-mentionContent-socialFrame"
                        [ngClass]="'agpr-mentionContent-socialFrame--' + mention.mediaType.id"
                        [src]="socialEmbedURL | agprBypassURLSecurity"
                        (load)="isSocialFrameLoaded = true"
                        [title]="iframeTitle"
                    ></iframe>
                    <iframe
                        *ngIf="socialEmbedCode"
                        class="agpr-mentionContent-socialFrame"
                        [ngClass]="'agpr-mentionContent-socialFrame--' + mention.mediaType.id"
                        [srcdoc]="socialEmbedCode"
                        (load)="isSocialFrameLoaded = true"
                        [title]="iframeTitle"
                    ></iframe>
                </div>
            </agpr-panel>
        </div>

        <agpr-mention-view-tveyes-panel
            [mention]="mention"
            [mentionSearch]="search"
            [highlightKeywords]="highlightKeywords"
        ></agpr-mention-view-tveyes-panel>
    </ng-template>
</ng-container>
